import { render, staticRenderFns } from "./gasClamp_down.vue?vue&type=template&id=893a9434&scoped=true"
import script from "./gasClamp_down.vue?vue&type=script&lang=js"
export * from "./gasClamp_down.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_down.vue?vue&type=style&index=0&id=893a9434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a9434",
  null
  
)

export default component.exports